import React from 'react';
import TextInputBase from './text-input-base';
import { ITextInputProps } from './text-input';

const EmailInput = ({
    name,
    label,
    onChange,
    maxLength,
    placeholder,
    value,
    error,
    required,
    groupAddOnBefore,
    groupAddOnAfter,
    showError,
}: ITextInputProps) => {
    return (
        <TextInputBase
            type="email"
            name={name}
            label={label}
            value={value}
            groupAddOnBefore={groupAddOnBefore}
            groupAddOnAfter={groupAddOnAfter}
            placeholder={placeholder}
            maxLength={maxLength}
            required={required}
            showError={showError}
            error={error}
            onChange={onChange}
        />
    );
};

export default EmailInput;
